import { on } from 'js/lib/events'
import { track } from '../component'

on('click', '.js-c-dog-trainer-promo-banner__cta', function () {
  track('click', 'dog_trainer_promo')
})
